import { useForm } from "react-hook-form";
import Button from "../../ui/Button";
import Form from "../../ui/Form";
import Input from "../../ui/Input";
import { useSignup } from "./useSignup";
import FormRowVertical from "../../ui/FormRowVertical.jsx";

// Email regex: /\S+@\S+\.\S+/

function SignupForm() {
    const { signup, isLoading } = useSignup();
    const { register, formState, getValues, handleSubmit, reset } = useForm();
    const { errors } = formState;

    function onSubmit({ fullName, email, password }) {
        signup(
            { fullName, email, password },
            {
                onSettled: () => reset(),
            }
        );
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <FormRowVertical label="Username" error={errors?.fullName?.message}>
                <Input
                    type="text"
                    id="fullName"
                    disabled={isLoading}
                    {...register("Username", { required: "This field is required" })}
                />
            </FormRowVertical>

            <FormRowVertical label="Email" error={errors?.email?.message}>
                <Input
                    type="email"
                    id="email"
                    disabled={isLoading}
                    {...register("email", {
                        required: "This field is required",
                        pattern: {
                            value: /\S+@\S+\.\S+/,
                            message: "Please provide a valid email address",
                        },
                    })}
                />
            </FormRowVertical>

            <FormRowVertical
                label="Password (min 8 characters)"
                error={errors?.password?.message}
            >
                <Input
                    type="password"
                    id="password"
                    disabled={isLoading}
                    {...register("password", {
                        required: "This field is required",
                        minLength: {
                            value: 8,
                            message: "Password needs a minimum of 8 characters",
                        },
                    })}
                />
            </FormRowVertical>

            <FormRowVertical label="Repeat password" error={errors?.passwordConfirm?.message}>
                <Input
                    type="password"
                    id="passwordConfirm"
                    
                    disabled={isLoading}
                    {...register("passwordConfirm", {
                        required: "This field is required",
                        validate: (value) =>
                            value === getValues().password || "Passwords need to match",
                    })}
                />
            </FormRowVertical>

            <FormRowVertical>
                {/* type is an HTML attribute! */}
                <Button disabled={isLoading}
                        size="small"
                >
                    Register
                </Button>
                
                <Button className={"m-8"}
                    variation="secondary"
                    size="small"
                    disabled={isLoading}
                    onClick={reset}
                >
                    Cancel
                </Button>
            </FormRowVertical>
        </Form>
    );
}

export default SignupForm;
